import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { flexCenter } from '../../commonUI/cssClasses';
import { roundFractional } from '../../ranches/ranchUtils';

type NumericSlotProps = {
  value: number | null | undefined;
  roundDigits?: number;
};

export const NumericSlot: React.FC<NumericSlotProps> = ({
  value,
  roundDigits,
}) => {
  const displayValue = useMemo(() => {
    // Check if value is a valid number
    if (value === undefined || value === null || Number.isNaN(value)) {
      return '--';
    }
    if (Number.isInteger(value)) {
      // Convert integer to string directly
      return value.toString();
    }
    return roundFractional(value, roundDigits);
  }, [value, roundDigits]);

  return (
    <Typography
      variant='subtitle1'
      sx={{
        ...flexCenter,
        color: (theme) => theme.colors.common.softWhite,
        p: '0.2rem',
        lineHeight: 1,
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        fontSize: {
          sm: '1.2rem',
          md: '1.4rem',
          lg: '1.6rem',
        },
      }}
    >
      {displayValue}
    </Typography>
  );
};
